.secondaryAction {
  display: flex;
  flex-direction: row;
  align-items: center;
  opacity: 0.6;
}

@media (prefers-reduced-motion: no-preference) {
  .secondaryAction {
    transition: opacity 0.2s;
  }
}

.listItemButton {
  padding: 8px;
  background: transparent;
}

/* Prevent double-hover: the parent ListItem handles the full-width
   hover highlight; the inner button should not add its own. */
.listItemButton.listItemButton:hover {
  background-color: transparent;
}
